import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {useQuery} from "@tanstack/react-query";
import garrisonAuditService from "../../../../services/reports/garrison-audit-service.js";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { data: vehiclesOpt} = useQuery({
        queryFn: () =>  garrisonAuditService.getAllVehicles(),
        queryKey: ['vehicles'],
        initialData: []
    });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form  className={'space-y-4'}>
                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart ? new Date(filters.dtStart) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label='Veículo'
                        isMulti={false}
                        wrapValues={true}
                        options={vehiclesOpt}
                        value={filters.vehicle}
                        onChange={(value) => setFilters(prev => ({...prev, vehicle: value}))}
                        instanceId="vehicle"
                        classNameWrapper={"w-full"}
                    />

                    <InputCheckbox id="onlyWithNews" checked={filters.onlyWithNews}
                                   label="Somente com QRU"
                                   onChange={({target: {checked}}) => setFilters(prev => ({...prev, onlyWithNews: checked}))}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;